import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';

const ALIGNMENT_DATA_KEY = 'text-align';

const SUPPORTED_ALIGNMENTS = ['left', 'center', 'right', 'justify'];

const alignmentOf = (block) => {
  const alignment = block.getData().get(ALIGNMENT_DATA_KEY);

  return SUPPORTED_ALIGNMENTS.includes(alignment) ? alignment : null;
};

const blockStyleFn = (block) => {
  const alignment = alignmentOf(block);

  if (!alignment) {
    return undefined;
  }

  return { style: { textAlign: alignment } };
};

const customBlockFn = (element) => {
  const alignment = element.style && element.style.textAlign;

  if (!SUPPORTED_ALIGNMENTS.includes(alignment)) {
    return {};
  }

  return { data: { [ALIGNMENT_DATA_KEY]: alignment } };
};

export const richTextToHtml = (contentState) => stateToHTML(contentState, { blockStyleFn });

export const richTextContentFromHtml = (html) => stateFromHTML(html, { customBlockFn });
